var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Collaborators',{attrs:{"scope-type":"contract-manager","scope-id":_vm.contractManagerId}})}
var staticRenderFns = []

export { render, staticRenderFns }